const resolvResult = (response) => {
    if (response === null || response === void 0 ? void 0 : response.Result) {
        return Array.isArray(response.Result) ? response.Result[0] : response.Result;
    }
    return undefined;
};
export const resolveDisclaimer = (response, disclaimerName, financingDisclaimersTextStyle) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    let disclaimer = '';
    const result = resolvResult(response);
    if (((_b = (_a = response === null || response === void 0 ? void 0 : response.Parameters) === null || _a === void 0 ? void 0 : _a[disclaimerName]) === null || _b === void 0 ? void 0 : _b['#cdata-section']) &&
        typeof ((_d = (_c = response === null || response === void 0 ? void 0 : response.Parameters) === null || _c === void 0 ? void 0 : _c[disclaimerName]) === null || _d === void 0 ? void 0 : _d['#cdata-section']) === 'string') {
        disclaimer = (_f = (_e = response === null || response === void 0 ? void 0 : response.Parameters) === null || _e === void 0 ? void 0 : _e[disclaimerName]) === null || _f === void 0 ? void 0 : _f['#cdata-section'];
    }
    else if (((_g = result === null || result === void 0 ? void 0 : result[disclaimerName]) === null || _g === void 0 ? void 0 : _g['#cdata-section']) &&
        typeof ((_h = result === null || result === void 0 ? void 0 : result[disclaimerName]) === null || _h === void 0 ? void 0 : _h['#cdata-section']) === 'string') {
        disclaimer = (_j = result === null || result === void 0 ? void 0 : result[disclaimerName]) === null || _j === void 0 ? void 0 : _j['#cdata-section'];
    }
    else if (((_l = (_k = response === null || response === void 0 ? void 0 : response.Parameters) === null || _k === void 0 ? void 0 : _k.Disclaimers) === null || _l === void 0 ? void 0 : _l[disclaimerName]) &&
        typeof ((_o = (_m = response === null || response === void 0 ? void 0 : response.Parameters) === null || _m === void 0 ? void 0 : _m.Disclaimers) === null || _o === void 0 ? void 0 : _o[disclaimerName]) === 'string') {
        disclaimer = (_q = (_p = response === null || response === void 0 ? void 0 : response.Parameters) === null || _p === void 0 ? void 0 : _p.Disclaimers) === null || _q === void 0 ? void 0 : _q[disclaimerName];
    }
    else if (((_r = result === null || result === void 0 ? void 0 : result.Disclaimers) === null || _r === void 0 ? void 0 : _r[disclaimerName]) &&
        typeof ((_s = result === null || result === void 0 ? void 0 : result.Disclaimers) === null || _s === void 0 ? void 0 : _s[disclaimerName]) === 'string') {
        disclaimer = (_t = result === null || result === void 0 ? void 0 : result.Disclaimers) === null || _t === void 0 ? void 0 : _t[disclaimerName];
    }
    else if (((_u = response === null || response === void 0 ? void 0 : response.Parameters) === null || _u === void 0 ? void 0 : _u[disclaimerName]) &&
        typeof ((_v = response === null || response === void 0 ? void 0 : response.Parameters) === null || _v === void 0 ? void 0 : _v[disclaimerName]) === 'string') {
        disclaimer = (_w = response === null || response === void 0 ? void 0 : response.Parameters) === null || _w === void 0 ? void 0 : _w[disclaimerName];
    }
    else if ((result === null || result === void 0 ? void 0 : result[disclaimerName]) && typeof (result === null || result === void 0 ? void 0 : result[disclaimerName]) === 'string') {
        disclaimer = result === null || result === void 0 ? void 0 : result[disclaimerName];
    }
    if (!financingDisclaimersTextStyle) {
        disclaimer = disclaimer.replace(/<\/?[^>]+(>|$)/g, '');
    }
    return disclaimer;
};
export function getFSAGDefaultProduct(productData) {
    if (Array.isArray(productData.Products.Product)) {
        const defaultProductFromFSAG = productData.Products.Product.find((product) => product['@Default'] === 'Yes') ||
            productData.Products.Product[0];
        return defaultProductFromFSAG;
    }
    return productData.Products.Product ? productData.Products.Product : undefined;
}
export const patchProductData = (productData, financeRequestData, productParameter, defaultProductData) => {
    if (!Array.isArray(productData) || !productParameter || !Object.keys(productParameter).length) {
        return;
    }
    const selectedProduct = productData.find((product) => product['@ID'] === productParameter['@ID']);
    if (!selectedProduct) {
        return;
    }
    if (financeRequestData.Product && !Array.isArray(financeRequestData.Product)) {
        financeRequestData = Object.assign(Object.assign({}, financeRequestData), { Product: { '@ID': selectedProduct['@ID'] } });
    }
    defaultProductData['@ID'] = selectedProduct['@ID'];
};
export const patchFormParameter = (defaultProductData, formParameter) => {
    if (!!formParameter && Object.keys(formParameter).length > 0) {
        return Object.assign(Object.assign({}, defaultProductData), { Parameter: formParameter });
    }
    return undefined;
};
export const getPaymentValue = (payment_, currencyPattern) => {
    let value = '';
    if (!payment_ || !Array.isArray(payment_)) {
        return value;
    }
    const payment = payment_.filter((object) => object['@ID'] === 'Rate');
    if (payment.length && payment[0].Data && payment[0].Units) {
        const unitSymbol = typeof payment[0].Units === 'string' ? payment[0].Units : payment[0].Units['@Symbol'];
        const unitText = typeof payment[0].Units === 'string' ? payment[0].Units : payment[0].Units['#text'];
        value = getPriceFormatted(payment[0].Data['#text'], unitSymbol, unitText, currencyPattern);
    }
    return value;
};
const getPriceFormatted = (value, unit = '', textUnit = '', pattern) => {
    if (value && pattern) {
        switch (pattern) {
            case '{{currency}}{{price}}':
                return `${unit !== '' ? unit : textUnit} ${value}`;
            case '{{price}}{{currency}}':
                return `${value} ${unit !== '' ? unit : textUnit}`;
            case '{{currency_text}}{{price}}':
                return `${textUnit !== '' ? textUnit : unit} ${value}`;
            case '{{price}}{{currency_text}}':
                return `${value} ${textUnit !== '' ? textUnit : unit}`;
            default:
                const displayTextUnit = textUnit !== '' ? textUnit : '';
                const displayUnit = unit !== '' ? unit : displayTextUnit;
                return `${value || ''} ${displayUnit}`;
        }
    }
    else {
        return '';
    }
};
export const mergeDeep = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, {
                        [key]: {},
                    });
                }
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, {
                    [key]: source[key],
                });
            }
        }
    }
    return mergeDeep(target, ...sources);
};
const isObject = (item) => {
    return item && typeof item === 'object' && !Array.isArray(item);
};
